import { useServicesContext } from '../../contexts/ServicesContext';
import { useMutation } from '@tanstack/react-query';

export enum GetCheckDraftArticleExistsByGuideIdMutationCacheKey {
  GetCheckDraftArticleExistsByGuideIdMutation = 'GetCheckDraftArticleExistsByGuideIdMutation',
}

export const useCheckGetDraftArticleExistsByGuideIdMutation = () => {
  const { checkExistsDraftByGuideId } = useServicesContext();
  return useMutation({
    mutationKey: [
      GetCheckDraftArticleExistsByGuideIdMutationCacheKey.GetCheckDraftArticleExistsByGuideIdMutation,
    ],
    mutationFn: (guideId: number) => checkExistsDraftByGuideId(guideId),
  });
};
